$("input").attr("autocomplete", "off");


$(document).on("focusin", function(e) {
    $("input").attr("autocomplete", "off");
    $('.tox-textfield').attr("autocomplete", "off")
});